import React, { useEffect, useState } from "react";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import Table from "../../components/Table";
import buscar_azul from "../../images/search_azul.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { useParams, useNavigate } from "react-router-dom";
import { Preloader } from "../../components/Preloader";
import { toast } from "react-toastify";
import ModalNuevoProveedor from "../../components/empresa_uno_comp/ModalNuevoProveedor";

import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { ApiService } from "../../components/ApiService";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import { useCompanyAssigned } from "../../components/CompanyAssignedContext";
import LupaIcon from "../../svg/lupaIcon";
import { returnFullURL } from "../../components";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";

export const Proveedores = ({ selectedSucursal, permisos }) => {
	const { nit, sub_direc } = useParams();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(true);

	const [data, setData] = useState([]); // Lista de proveedores
	const [citys, setCitys] = useState([]); // Lista de ciudades
	const [filteredData, setFilteredData] = useState([]); // Lista filtrada para la búsqueda
	const [search, setSearch] = useState(""); // Texto de búsqueda
	const [loading, setLoading] = useState(true); // Estado de carga
	const [isModalOpen, setIsModalOpen] = useState(false);

	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


	// Columnas de la tabla
	const columns = [
		{
			name: "Nombre",
			selector: (row, index) => row.supplier, // Contador
			sortable: true,
		},
		{
			name: "Empresa",
			selector: (row) => row.name, // Nombre del proveedor
			sortable: true,
		},
		{
			name: "Teléfono",
			cell: (row) => (
				<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<span>{row.phone || "Sin teléfono"}</span>
					{row.phone && (
						<a
							href={`https://wa.me/${row.phone}`}
							target="_blank"
							rel="noopener noreferrer"
							style={{
								backgroundColor: "#25D366",
								borderRadius: "50%",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								width: "24px",
								height: "24px",
								textDecoration: "none",
							}}>
							<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
						</a>
					)}
				</div>
			),
			sortable: true,
		},
		{
			name: "Ciudad",
			selector: (row) => row.location || "Sin ubicación", // Ubicación del proveedor
			sortable: true,
		},
		{
			name: "Acciones",
			cell: (row) => (
				<button className="btn-view" onClick={() => handleView(row)}>
					<FontAwesomeIcon icon={faEye} style={{ fontSize: "12px", color: "#fff" }} />
				</button>
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
	];

	const handleView = (row) => {
		console.info("Funcionalidad aun no diponible");
	};

	// Función para obtener la lista de proveedores desde la API
	const fetchSuppliers = async () => {
		setLoading(true);
		try {
			const url = `api/company/supplier/list?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al cargar los proveedores");
			}

			setData(response.supplier || []); // Guardar la lista de proveedores
			setFilteredData(response.supplier || []); // Inicializar los datos filtrados
			setCitys(response.city || []);
		} catch (error) {
			console.error("Error al cargar los proveedores:", error);
			toast.error("Error al cargar los proveedores");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (permisos?.leer) {
			fetchSuppliers();
		}
	}, [selectedSucursal, permisos]);

	// Actualizar la lista al guardar un nuevo proveedor
	const handleSaveProveedor = (newSupplier) => {
		// Transformar el nuevo proveedor para que coincida con los datos de la tabla
		const formattedSupplier = {
			name: newSupplier.company,
			phone: newSupplier.fullPhone,
			location: newSupplier.city,
		};
		// Actualizar la lista de proveedores y cerrar el modal
		setData((prevData) => [...prevData, formattedSupplier]);
		setFilteredData((prevData) => [...prevData, formattedSupplier]);
		setIsModalOpen(false);
		// Notificación de éxito
		// toast.success("Proveedor agregado exitosamente");
	};

	// Filtrar los datos en la tabla
	useEffect(() => {
		if (search.length > 1) {
			const filtered = data.filter(
				(item) =>
					item.name.toLowerCase().includes(search.toLowerCase()) ||
					(item.location && item.location.toLowerCase().includes(search.toLowerCase()))
			);
			setFilteredData(filtered);
		} else {
			setFilteredData(data);
		}
	}, [search, data]);

	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Proveedores</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} valor={search} setValor={(event) => setSearch(event.target.value)} placeholder="Proveedores"/>

				{/* Only show Add Proveedor button if user has permission */}
				{permisos?.editar && (
					<div className="content-btn-add">
						<Button
							variant="contained"
							sx={{ fontWeight: "bold", letterSpacing: "1px", background: 'var(--theme-company)' }}
							onClick={() => setIsModalOpen(true)}>
							Nuevo Proveedor
						</Button>
					</div>
				)}
			</div>

			<div className="datatable-container">
				{loading ? (
					<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
						<Box sx={{ textAlign: "center" }}>
							<CircularProgress />
							<Typography variant="body1" sx={{ mt: 2 }}>
								Cargando permisos...
							</Typography>
						</Box>
					</Box>
				) : (
					currentSize > 480 ? (
						<div className="table-view-pc">
							<Table columns={columns} data={filteredData} />
						</div>
					) : (
						<TablesMobile filteredData={(filteredData ?? []).map(obj => ({
							img: null,
							title: obj?.supplier,
							texto: obj?.name,
							fullPhone: obj?.phone,
						}))} whatsapp={true} />
					)
				)}
			</div>

			{/* Only render the modal if user has permission to add providers */}
			{permisos?.editar && <ModalNuevoProveedor
				list_city={citys.map((text_value) => {
					return { value: text_value, label: text_value };
				})}
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				onSave={handleSaveProveedor}
				selectedSucursal={selectedSucursal}
			/>}
		</>
	);
};
